import { withTranslation } from "react-i18next";
import React, { Component } from "react";
import "./styles.css";
import ResultItem from "./ResultItem";
import Api from "../../../lib/Api";
import MoreInfo from "../../../lib/MoreInfo";
import Filters from "./Filters";
import ResultMessage from "./ResultMessage";
import Subscription from "../../../lib/Subscription";
import { connect } from "react-redux";
import { getResultVars } from "../../Bikefit/lib/bikefit";
import Locale from "../../../lib/Locale";
import Popup from "../../../lib/Popup";
import MailPopup from "./MailPopup";
import Newsletter from "../../../lib/Newsletter";
import Loader from "../../Loader";

class Result extends Component {
  constructor(props) {
    super(props);

    let positionFilter = this.props.speed;
    if (this.props.position !== undefined && this.props.position !== null) {
      positionFilter = parseInt(this.props.position, 10);
    }

    let brands = this.props.selectedBrands
      ? this.props.selectedBrands.split(", ")
      : [];
    let filterFrame = this.props.filterFrame
      ? this.props.filterFrame.split(", ")
      : [];
    let filterChainRings = this.props.filterChainRings
      ? this.props.filterChainRings.split(", ")
      : [];
    let cassette = this.props.cassette ? this.props.cassette.split(", ") : [];

    this.state = {
      showFilters: false,
      loading: false,
      data: "",
      maxPrice: this.props.price,
      maxWeight: this.props.maxWeight,
      sex: this.props.sex,
      gender: this.props.gender,
      image: this.props.image,
      filterSuspension: parseInt(this.props.suspension, 10),
      filterPosition: positionFilter,
      filterBrand: brands,
      filterBrake: this.props.filterBrake ? this.props.filterBrake : "",
      filterFrame: filterFrame,
      filterWheel: [],
      filterWheelString: "",
      filterChainRings: filterChainRings,
      filterCasette: cassette,
      more_info: "",
      selected: "",
      measure: this.props.measure,
      error: false,
      availableBrands: [],
      filterYear: this.props.filterYear
        ? parseInt(this.props.filterYear, 10)
        : 2024,
      hasSubscription: false,
    };
  }

  subscriptionClicked = () => {
    Subscription.paywall("bikefinder", this.props.traject);
  };

  componentDidMount() {
    this.getAvailableBrands();
    this.updateProps({}, this.props);
    Subscription.checkSubscription("bikefinder").then((success) => {
      this.setState({ hasSubscription: success }, () => {
        if (!success) {
          this.filterYear(2024);
        }
      });
    });
    // scroll back to top page
    window.scrollTo(0, 0);
    //console.log(Newsletter.getLocalEntry())
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.updateProps(this.props, nextProps);
  }

  updateProps(currentProps, nextProps) {
    const dependentProps = [
      "speed",
      "position",
      "selectedBrands",
      "price",
      "maxWeight",
      "sex",
      "gender",
      "image",
      "suspension",
      "filterBrake",
      "filterYear",
      "measure",
    ];
    const changed = dependentProps.reduce((changed, propKey, i) => {
      return nextProps[propKey] !== currentProps[propKey] || changed;
    }, false);

    if (!changed) return;

    let positionFilter = nextProps.speed;
    if (nextProps.position !== undefined && nextProps.position !== null) {
      positionFilter = parseInt(nextProps.position, 10);
    }

    const brands = nextProps.selectedBrands
      ? nextProps.selectedBrands.split(", ")
      : [];
    const filterFrame = nextProps.filterFrame
      ? nextProps.filterFrame.split(", ")
      : [];
    const filterChainRings = nextProps.filterChainRings
      ? nextProps.filterChainRings.split(", ")
      : [];
    const cassette = nextProps.cassette ? nextProps.cassette.split(", ") : [];

    this.setState(
      {
        maxPrice: nextProps.price,
        maxWeight: nextProps.maxWeight,
        sex: nextProps.sex,
        gender: nextProps.gender,
        image: nextProps.image,
        filterSuspension: parseInt(nextProps.suspension, 10),
        filterPosition: positionFilter,
        filterBrand: brands,
        filterBrake: nextProps.filterBrake ? nextProps.filterBrake : "",
        filterFrame: filterFrame,
        filterChainRings: filterChainRings,
        filterYear: nextProps.filterYear
          ? parseInt(nextProps.filterYear, 10)
          : 2024,
        filterCasette: cassette,
        measure: nextProps.measure,
      },
      () => this.getResult()
    );
  }

  render() {
    if (this.state.error) {
      return (
        <div className="container-fluid main">
          <div className="text-center pt-4">
            <h2>{this.props.t("Error-message")}</h2>
            <a
              to={Locale.getUrlForCurrentLocale('/' + this.props.traject + '/advice/experience')}>{this.props.t('Ga terug')}
            </a>
          </div>
        </div>
      );
    }

    if (this.state.data && !this.state.loading) {
      var json_result = this.state.data.data;
      var resultsObj = {};

      for (let [i, d] of Object.entries(json_result)) {
        resultsObj[i] = {
          rank: i,
          bike_model: d.bike_model,
          geo_fit: d.geo_fit,
          summary: d.summary,
        };
      }

      var selectMtb = this.selectMtb;
      var traject = this.props.traject;
      var t = this.props.t;
      var indents = Object.values(resultsObj).map(function (item, i) {
        if (i > 2) {
          return (
            <ResultItem
              key={i}
              item={item}
              selectMtb={selectMtb}
              traject={traject}
              t={t}
            />
          );
        } else {
          return null;
        }
      });

      var theResults = Object.values(resultsObj).map(function (item, index) {
        if (index < 3) {
          return (
            <ResultItem
              key={index}
              item={item}
              selectMtb={selectMtb}
              traject={traject}
              t={t}
            />
          );
        } else {
          return null;
        }
      });

      let partsActive =
        this.isNumeric(this.props.driveChainWeight) ||
        this.isNumeric(this.props.suspensionWeight) ||
        this.isNumeric(this.props.wheelsWeight) ||
        this.isNumeric(this.props.brakesWeight) ||
        this.isNumeric(this.props.guaranteeWeight) ||
        this.isNumeric(this.props.weightWeight);
      let sortingActive =
        (this.props.sorting && this.props.sorting !== "BALANCED") || false;
      return (
        <div className="container-fluid main">
          <div className="info-overlay"></div>
          <div className="more-info result">
            <i className="closeInfo fas fa-times"></i>
            <div className="more-info-container"></div>
          </div>
          <div className="row result">
            <div className="col-12 top-bar">
              <div className="row">
                <div className="col-sm-3">
                  <button className="back btn btn-link" onClick={this.goBack}>
                    <i className="fas fa-caret-left"></i>{" "}
                    {this.props.t("Terug naar vorige stap")}
                  </button>
                </div>
                <div className="col-sm-9 text-center">
                  <div className="row">
                    <h2 className="desktop-title d-none d-lg-block">{this.props.t("Advies voor jou")}</h2>
                    <div
                      className={
                        this.state.hasSubscription
                          ? "col-9 col-sm-9 col-lg-9 text-left text-sm-center"
                          : "with-unlock col-12 col-sm-5 col-lg-6 text-left text-sm-center"
                      }
                    >
                      <h2 className="d-block d-lg-none">{this.props.t("Advies voor jou")}</h2>
                    </div>

                    {!this.state.hasSubscription && (
                      <div className="col-6 col-sm-4 col-lg-3 text-left text-sm-center">
                        <button
                          className="btn btn-primary"
                          onClick={this.subscriptionClicked}
                        >
                          {t("Result_Subscribe")}
                        </button>
                      </div>
                    )}
                    <div className="col-6 col-sm-3 col-lg-3 text-left text-lg-right">
                      <button
                        className="btn btn-primary"
                        onClick={this.showMailPopup}
                      >{this.props.t("Result_send_report")}</button>
                      <div id="advanced-settings" className="btn-group">
                        <button
                          type="button"
                          className="btn dropdown-toggle"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <img
                            className="img-responsive"
                            src="/img/logo-gear.png"
                            alt="Advies"
                          />
                          {(partsActive || sortingActive) && (
                            <span className="active-icon"></span>
                          )}
                        </button>
                        <div className="dropdown-menu dropdown-menu-right">
                          <a
                            className={
                              partsActive
                                ? "dropdown-item active-icon"
                                : "dropdown-item"
                            }
                            href={this.props.path + "/weighing-factors/parts"}
                          >
                            {this.props.t("Result_WeighingFactorParts")}
                          </a>
                          <a
                            className={
                              sortingActive
                                ? "dropdown-item active-icon"
                                : "dropdown-item"
                            }
                            href={this.props.path + "/weighing-factors/geo"}
                          >
                            {this.props.t("Result_WeighingFactorGeo")}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Filters
              showFilters={this.state.showFilters}
              changePriceEnter={this.changePriceEnter}
              changePrice={this.changePrice}
              maxPrice={this.state.maxPrice}
              maxWeight={this.state.maxWeight}
              changeWeight={this.changeWeight}
              changeWeightEnter={this.changeWeightEnter}
              year={this.state.filterYear}
              filterYear={this.filterYear}
              sex={this.state.sex}
              filterSex={this.filterSex}
              filterSuspension={this.state.filterSuspension}
              setFilterSuspension={this.filterSuspension}
              filterBrand={this.state.filterBrand}
              handleFilterBrand={this.filterBrand}
              filterWheel={this.state.filterWheel}
              handleFilterWheel={this.filterWheel}
              filterChainRings={this.state.filterChainRings}
              handleFilterChainRings={this.filterChainRings}
              filterBrake={this.state.filterBrake}
              setFilterBrake={this.filterBrake}
              filterCasette={this.state.filterCasette}
              handleFilterCasette={this.filterCasette}
              filterFrame={this.state.filterFrame}
              setFilterFrame={this.filterFrame}
              availableBrands={this.state.availableBrands}
              measure={this.state.measure}
              oldMeasure={this.state.old_measure}
              filterPosition={this.state.filterPosition}
              setFilterPosition={this.filterPosition}
              traject={this.props.traject}
              hasSubscription={this.state.hasSubscription}
            />
            <div className="col-sm-9">
              <ResultMessage
                bikeType={this.props.bikeType}
                message={this.state.message}
                noResults={this.state.noresults}
              />

              <div className="row">
                <div className="col-12 intro text-center">
                  <p>
                    {this.props.t("Result_TitleStart")}
                    <strong> {this.props.t("ervaring")}</strong>{" "}
                    {this.props.t("en")}{" "}
                    <strong>{this.props.t("fietsdoelen")}</strong>{" "}
                    {this.props.t("is het volgende")}{" "}
                    {this.props.t(
                      this.props.traject === "mtb"
                        ? "Result_TitleEndMountainbike"
                        : "Result_TitleEndRace"
                    )}{" "}
                    <span
                      className="link moreInfo"
                      onClick={() => {
                        MoreInfo.show("info", "result");
                      }}
                    >
                      {this.props.t("Meer informatie")}
                    </span>
                  </p>
                </div>

                <div onClick={() => this.setState({ showFilters: !this.state.showFilters })} className="toggle-filters">{this.props.t("Filters")}</div>
                {theResults}
              </div>

              <div id="more-results" className="row">
                {indents}
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="loader">
          <div className="resultloader">
            <p>{this.props.t("Result-Op dit moment")}</p>
            <Loader />
            {/* <img className="loadergif" src="/img/framefit_1.gif" alt="Loader..." /> */}
          </div>
        </div>
      );
    }
  }

  getAvailableBrands = () => {
    var url = "/brand";

    Api.get(url, { bike_type: this.props.bikeType }).then((response) => {
      let availableBrands = response.data.data || [];
      this.setState({ availableBrands: availableBrands });

      if (
        availableBrands.reduce(
          (total, curr) => total && this.state.filterBrand.indexOf(curr) !== -1,
          true
        )
      ) {
        this.setState({ filterBrand: [] });
      }
    });
  };

  getResult = () => {
    this.setState({ loading: true });

    let bike_cat = "MTB";
    if (this.props.traject === "race") {
      bike_cat = "Race";
    }

    let getVars = {
      bike_cat: bike_cat,
      speed: this.props.speed,
      position: this.state.filterPosition,
      image: this.state.image,
      experience: this.props.experience,
      parcour_type: this.props.parcourType,
      usage: this.props.usage,
      suspension: this.props.suspension,
      gents_ladies: this.state.sex,
      max_price: this.state.maxPrice,
      weight: this.props.weight,
      max_weight: this.state.maxWeight * 1000,
      filterSuspension: this.state.filterSuspension,
      filterBrand: this.state.filterBrand,
      filterFrame: this.state.filterFrame,
      filterBrake: this.state.filterBrake,
      filterWheel: this.state.filterWheelString,
      filterChainRings: this.state.filterChainRings,
      filterCasette: this.state.filterCasette,
      year: this.state.filterYear,
    };
    if (this.props.sorting !== null) {
      getVars["sort_method"] = this.props.sorting;
    }
    if (this.props.driveChainWeight !== null) {
      getVars["driveChainWeight"] = this.props.driveChainWeight;
    }
    if (this.props.suspensionWeight !== null) {
      getVars["suspensionWeight"] = this.props.suspensionWeight;
    }
    if (this.props.brakesWeight !== null) {
      getVars["brakesWeight"] = this.props.brakesWeight;
    }
    if (this.props.guaranteeWeight !== null) {
      getVars["guaranteeWeight"] = this.props.guaranteeWeight;
    }
    if (this.props.weightWeight !== null) {
      getVars["weightWeight"] = this.props.weightWeight;
    }
    if (this.props.wheelsWeight !== null) {
      getVars["wheelsWeight"] = this.props.wheelsWeight;
    }

    let url;

    switch (this.state.measure) {
      case "mtb":
        getVars["mtbSadleheight"] = this.props.mtbSadleheight * 10;
        getVars["mtbSetback"] = this.props.mtbSetback * 10;
        getVars["mtbLength"] = this.props.mtbLength * 10;
        getVars["mtbDrop"] = this.props.mtbDrop * 10;
        getVars["mtbSuspension"] = this.props.mtbSuspension * 10;
        getVars["mtbFully"] = this.props.mtbFully;
        getVars["mtbSadleground"] = this.props.mtbSadleground * 10;
        getVars["mtbSteerground"] = this.props.mtbSteerground * 10;

        url = "/mtb-result";
        break;

      case "body":
        url = "/result";

        getVars["length"] = this.props.length;
        getVars["inner_leg_length"] = this.props.inner_leg;
        getVars["torso"] = this.props.romp;
        getVars["age"] = this.props.age;
        getVars["arm"] = this.props.arm;
        getVars["shoe"] = 0;
        getVars["upper_leg"] = 0;
        break;

      case "race":
        url = "/racebike-result";

        getVars["raceSadleheight"] = this.props.raceSadleheight * 10;
        getVars["raceSetback"] = this.props.raceSetback * 10;
        getVars["raceLength"] = this.props.raceLength * 10;
        getVars["raceDrop"] = this.props.raceDrop * 10;
        getVars["raceSadleground"] = this.props.raceSadleground * 10;
        getVars["raceSteerground"] = this.props.raceSteerground * 10;
        break;
      case "bikefit":
        url = "/integrated-bikefinder-bikefit";

        delete getVars["position"];

        if (this.props.savedResults === "true") {
          const lastResults = JSON.parse(
            localStorage.getItem("last_result_advice")
          );
          const lastChoices = getResultVars(
            JSON.parse(localStorage.getItem("last_result_choices"))
          );

          getVars = { ...getVars, ...lastChoices, ...lastResults };
        } else {
          const choices = getResultVars(this.props.bikefit.choices);
          getVars = { ...getVars, ...choices };
        }

        break;
      default:
        url = "/nofit-result";
        break;
    }

    Api.get(url, getVars)
      .then((response) => {
        // alert((response.data.response || {}).status)
        if ((response.data.response || {}).status === 1016) {
          Subscription.paywall("bikefinder", this.props.traject);
        }

        if (this.props.chosenIntegrationOption === "option2") {
          this.saveLastBikefit(this.props.bikefit.choices, response);
        }

        this.setState({ message: response.data.message, error: false });
        if (
          String(response.data.message) ===
          "3: Many models in selection and no fit"
        ) {
          this.props.setLastUsedMeasure("no");
          this.setState(
            { measure: "no", old_measure: this.state.measure, noresults: true },
            () => this.getResult()
          );
        } else {
          const newState = { data: response.data };
          this.props.setLastUsedMeasure(this.state.measure);
          if (
            this.state.measure === this.state.old_measure &&
            this.state.noresults
          ) {
            newState["noresults"] = false;
          }
          this.setState(newState);
        }

        if (!this.state.mailPopup && !Newsletter.shownBefore()) {
          this.showMailPopup();
        }
      })
      .catch((response) => {
        this.setState({ error: true });
      })
      .finally(() => {
        this.setState({ loading: false })
      });
  };

  saveLastBikefit = (choices, response) => {
    localStorage.setItem("last_result_choices", JSON.stringify(choices));
    localStorage.setItem("last_result_advice", JSON.stringify(response.data.bikefit));
  };

  showMailPopup = () => {
    Newsletter.setShownBefore();
    this.setState({ mailPopup: true })

    const choices = this.props.savedResults === "true"
      ? JSON.parse(localStorage.getItem("last_result_choices"))
      : this.props.bikefit.choices;

    let data = {
      experience: this.props.experience,
      position: this.state.filterPosition,
      backAngle: this.props.measure === 'bikefit' ? getResultVars(choices).back_angle : 0,
      maxPrice: this.state.maxPrice,
      year: this.state.filterYear,
      gender: this.state.sex,
      brands: this.state.filterBrand,
      frame: this.state.filterFrame,
      suspension: this.props.suspension,
      sorting: this.props.sorting,
      bikeType: this.props.mtb_type,
      bikeCat: this.props.traject,
      measure: this.props.measure
    }
    Popup.show(<MailPopup bikes={this.state.data.data} traject={this.props.traject} data={data} />, true);
  };

  filterSuspension = (value) => {
    this.props.setSuspension(value);
  };

  filterYear = (year) => {
    if (year !== this.state.filterYear) {
      this.props.setFilterYear(year);
    }
  };

  filterSex = (value) => {
    this.props.setSex(value);
  };

  filterPosition = (value) => {
    if (this.state.old_measure === "body") {
      this.setState({ measure: "body" }, () => {
        this.props.setPosition(value);
      });
    } else {
      this.props.setPosition(value);
    }
  };

  filterBrand = (event) => {
    let availableBrands = this.state.availableBrands || [];
    var brands = this.state.filterBrand;
    var brand = event.target.innerHTML;
    var index = brands.indexOf(brand);
    if (index < 0) {
      brands.push(brand);
    } else {
      brands.splice(index, 1);
    }

    if (
      availableBrands.reduce(
        (prev, curr) => prev && brands.indexOf(curr) !== -1,
        true
      )
    ) {
      brands = [];
    }

    this.props.handler(brands);
    this.setState({ filterBrand: brands }, () => {
      this.getResult();
    });
  };

  filterFrame = (frame) => {
    var frames = this.state.filterFrame;
    var index = frames.indexOf(frame);
    if (index < 0) {
      frames.push(frame);
    } else {
      frames.splice(index, 1);
    }
    this.props.setFilterFrame(frames);
    this.setState({ filterFrame: frames }, () => {
      this.getResult();
    });
  };

  filterBrake = (brake) => {
    if (this.state.filterBrake === brake) {
      brake = "";
    }
    this.props.setFilterBrake(brake);
    this.setState({ filterBrake: brake }, () => {
      this.getResult();
    });
  };

  filterWheel = (event) => {
    var wheels = this.state.filterWheel;
    var wheel = event.target.innerHTML;
    var index = wheels.indexOf(wheel);
    if (index < 0) {
      wheels.push(wheel);
    } else {
      wheels.splice(index, 1);
    }
    var new_wheels = wheels.join("-");
    this.setState({ filterWheel: wheels });
    this.setState({ filterWheelString: new_wheels }, () => {
      this.getResult();
    });
  };

  filterCasette = (event) => {
    var casettes = this.state.filterCasette;
    var casette = event.target.innerHTML;
    var index = casettes.indexOf(casette);
    if (index < 0) {
      casettes.push(casette);
    } else {
      casettes.splice(index, 1);
    }
    this.props.setCassette(casettes);
    this.setState({ filterCasette: casettes }, () => {
      this.getResult();
    });
  };

  filterChainRings = (event) => {
    var chainRings = this.state.filterChainRings;
    var chainRing = event.target.innerHTML;
    var index = chainRings.indexOf(chainRing);
    if (index < 0) {
      chainRings.push(chainRing);
    } else {
      chainRings.splice(index, 1);
    }
    this.props.setFilterChainRings(chainRings);
    this.setState({ filterChainRings: chainRings }, () => {
      this.getResult();
    });
  };

  changePrice = (event) => {
    this.props.changePrice(event.target.value);
  };

  changeWeight = (event) => {
    var weight = event.target.value;
    localStorage.setItem("max_weight", weight);
    this.setState({ maxWeight: weight }, () => {
      this.getResult();
    });
  };

  changePriceEnter = (event) => {
    if (event.key === "Enter") {
      this.props.changePrice(event.target.value);
    }
  };

  changeWeightEnter = (event) => {
    if (event.key === "Enter") {
      var weight = event.target.value;
      this.setState({ maxWeight: weight }, () => {
        this.getResult();
      });
    }
  };

  selectMtb = (selected) => {
    this.props.select(selected);
    this.props.goTo("/advice/result_bike", this.props.traject);
  };

  handleSubmit = () => {
    let url = "/postresult";
    let getVars = {
      mtb_type: this.props.mtb_type,
      inner_leg_length: this.props.leg,
      speed: this.props.speed,
      length: this.props.length,
      upperbody_length: this.props.romp,
      arm_length: this.props.arm,
      weight: this.props.weight,
      experience: this.props.experience,
      parcour_type: this.props.parcourType,
      usage: this.props.usage,
      suspension: this.props.suspension,
      sex: this.props.sex,
      gender: this.state.gender,
      max_price: this.state.maxPrice,
      max_weight: this.state.maxWeight * 1000,
    };
    this.props.post(url, {}, getVars);
  };

  isNumeric = (n) => {
    return !isNaN(parseFloat(n)) && isFinite(n);
  };

  goBack = () => {
    this.props.goTo("/advice/price", this.props.traject);
  };
}

const mapStateToProps = (store) => {
  return {
    bikefit: store.bikefit,
  };
};

const mapDispatchToProps = () => ({});

export default withTranslation("result")(
  connect(mapStateToProps, mapDispatchToProps)(Result)
);
